import React from 'react';
import { connect } from 'react-redux';
import Router, { withRouter } from 'next/router';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import Icon from '@ertelecom/ui-react/components/icon';
import InterestingBlock from '@ertelecom/ui-react/components/blocks/interestingBlocks';
import ThemedChannels from '../../components/Channels/themed';
import ChannelSearchResult from '../../components/Channels/searchResult';
import { data } from '~/src/components/DomRuTv/data';
import * as ST from './styled';
import { EVENTS } from '~/src/constants/analytics';

const sendEvent = (label) => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: 'Domru tv',
        action: 'Filter_сhannel',
        label
    });
};

const scrollIntoView = () => {
    if (window && document) {
        const target = document.getElementById('filters_header');
        if (target === null) {
 return;
}
        const top = target.style.marginTop;
        const menuHeight = window.matchMedia('(max-width: 859px)').matches ? 50 : 0;
        target.style.marginTop = `-${menuHeight}px`;
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        target.style.marginTop = top;
    }
};

Router.events.on('routeChangeComplete', () => {
    setTimeout(scrollIntoView, 200);
});

class DomruChannels extends React.Component {
    state = {
        windowWidth: 1920,
        selectedTheme: null,
        showSearchResults: false,
    }

    searchRef = React.createRef();

    componentDidMount() {
        const { router: { query: { search } }, channels } = this.props;

        this.search(channels.find(i => i.id == Number(search) || 0));
    }

    componentDidUpdate(prevProps) {
        const prevSearch = Number(prevProps.router.query.search) || 0;
        const search = Number(this.props.router.query.search) || 0;
        if (prevSearch !== search) {
            const currElem = this.searchRef?.current;
            currElem?.refs?.input?.blur();
            this.search(this.props.channels.find(i => i.id == search));
        }
    }

    setFilter = (selected) => {
        if (selected) {
            setTimeout(scrollIntoView, 200);
            sendEvent(selected.name);
        }
        this.setState({
            selectedTheme: selected
        });

    }

    getPackageChannels = (pack, sortingField) => {
        if (pack.channels) {
            return;
        }
        const { themedChannelsArray } = this.props;
        let count = 0;
        pack.channels = themedChannelsArray.reduce((result, theme) => {
            const filteredChannels = theme.channels.filter(ch => ch[sortingField] && ch[sortingField].indexOf(pack.id) !== -1);
            const currentCount = filteredChannels.length;
            if (currentCount > 0) {
                count += currentCount;
                result.push({
                    name: theme.name,
                    channels: filteredChannels
                });
            }
            return result;
        }, []);
        pack.channelsCount = count;

    }

    routerPushSearch = value => {
        const { router } = this.props;
        const { pathname, query } = router;

        router.push({
            pathname,
            query: value
                ?   {
                    ...query,
                    search: value,
                    }
                : null,
        });
    };

    onSearch = item => {
        sendEvent('search');
        this.routerPushSearch(item.id);
    };

    search = (item) => {
        if (item && item.id) {
            item.salePackages.forEach(pack => this.getPackageChannels(pack, 'salePackageIds'));
            item.channelPackages.forEach(pack => this.getPackageChannels(pack, 'channelPackageIds'));

            this.setState({
                showSearchResults: true,
                foundChannel: item
            });
        } else if (this.state.showSearchResults) {
            this.resetSearch();
        }
    }

    resetSearch = () => {
        this.setState({
            showSearchResults: false,
            foundChannel: null
        });
    }

    renderPageContent = () => {
        const { themedChannels, themedChannelsArray } = this.props;

        const { selectedTheme, showSearchResults, foundChannel } = this.state;

        const sortedThemes = selectedTheme ? [themedChannels[selectedTheme.value]] : themedChannelsArray;

        if (showSearchResults) {
            return <ChannelSearchResult channel={foundChannel} />;
        }

        const renderChannels = sortedThemes.map((theme, key) => <ThemedChannels key={key} theme={theme} />);

        return renderChannels.length > 0
            ?   <ST.MainContent>
                    {renderChannels}
                </ST.MainContent>
            :   null;
    };

    render() {
        const { themes, city, themedChannels, channels } = this.props;

        const { selectedTheme, showSearchResults } = this.state;

        return (
            <ST.Wrapper>
                <ST.Banner isAuth={true} >
                    <ST.Content>
                        <ST.BannerHeader>ТВ-каналы от Дом.ru в {city.cityIn}</ST.BannerHeader>
                    </ST.Content>
                </ST.Banner>
                <ST.FiltersHeader id='filters_header'>
                    <ST.FiltersContent>
                        {showSearchResults &&
                            <ST.Link
                                onClick={() => this.routerPushSearch(null)}
                            >
                                <Icon color={COLORS.blue} content='\e654' />
                                <p>К списку каналов</p>
                            </ST.Link>
                        }

                        <ST.Search
                            placeholder='Найдите канал'
                            items={channels}
                            onSearch={this.onSearch}
                            searchRef={this.searchRef}
                        />

                        {!showSearchResults &&
                            <ST.ThemeFilter
                                options={themes}
                                onChange={this.setFilter}
                                selected={selectedTheme}
                            />
                        }
                    </ST.FiltersContent>
                </ST.FiltersHeader>
                {themedChannels &&
                    <ST.Content>
                        {this.renderPageContent()}

                        <InterestingBlock
                            list={data}
                            blocksTitle='Вам может быть интересно'
                        />
                    </ST.Content>
                }
            </ST.Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    isAuth: state.auth.isAuth,
});

export default withRouter(connect(
    mapStateToProps,
    null,
    null,
    {
        pure: false,
    },
)(DomruChannels));
